jQuery(($) => {
	$(".tour").on("click", () => {
		console.log("tour");

		$(".tour").removeClass("active");
		$(".interior-map").addClass("active");
		$(".view-map").removeClass("active");
		$(".view-tour").addClass("active");
	});
	$(".interior-map").on("click", () => {
		console.log("map");

		$(".tour").addClass("active");
		$(".interior-map").removeClass("active");

		$(".view-tour").removeClass("active");
		$(".view-map").addClass("active");
	});
});
